import { CompetitionsMenuSchema } from '@/views/sports/components/CompetitionsMenu/styles/CompetitionsMenu.styles';

export const competitionsMenuStyles: CompetitionsMenuSchema = {
  accordion: {
    color: 'alpha.800',
    minW: '190px',
    mr: '3',
    height: 'fit-content',
    boxShadow: 'md',
    borderRadius: 'md',
    overflow: 'hidden',
  },
  accordionItem: {
    outline: 'none',
    border: 'none',
  },
  accordionButton: {
    px: '3',
    py: '2',
    bgGradient: 'linear(to-b, alpha.300, alpha.700)',
    color: 'white',
    _hover: { bgGradient: 'linear(to-b, alpha.300, alpha.700)' },
  },
  accordionHeadingText: {
    flex: '1',
    fontSize: 'sm',
    textAlign: 'left',
    fontWeight: 'bold',
  },
  accordionIcon: {
    color: 'white',
  },
  accordionPanel: {
    p: '0',
    fontSize: 'xs',
    bg: 'alpha.50',
    color: 'alpha.800',
    fontWeight: 'medium',

    _last: {
      border: 'none',
    },
  },
};
